import { Cart, CartItem } from '../models/cart.model';
import { Product } from '../models/product.model';
import { MetaPixelContentItem, MetaPixelPurchaseInput } from './meta-pixel.types';
import { resolveMerchantId } from './merchant-id.util';

export const META_PIXEL_CURRENCY = 'EGP';

export function getProductUnitPrice(product: Pick<Product, 'price' | 'discountPrice'>): number {
  const discount = product.discountPrice;
  if (discount != null && discount > 0) {
    return discount;
  }
  return product.price;
}

export function cartItemToMetaContent(item: CartItem): MetaPixelContentItem {
  return {
    id: resolveMerchantId(item.product ?? { id: item.productId }),
    quantity: item.quantity,
    item_price: item.unitPrice,
  };
}

export function buildCartContents(cart: Cart): MetaPixelContentItem[] {
  return (cart.cartItems ?? []).map(cartItemToMetaContent);
}

export function buildCartContentIds(cart: Cart): string[] {
  return (cart.cartItems ?? []).map((item) => resolveMerchantId(item.product ?? { id: item.productId }));
}

export function buildCartValue(cart: Cart): number {
  return cart.cartItems?.reduce((sum, item) => sum + item.totalPrice, 0) ?? cart.totalAmount ?? 0;
}

export function buildCartNumItems(cart: Cart): number {
  return cart.cartItems?.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
}

export function buildPurchaseInputFromCart(
  orderNumber: string,
  orderId: number | undefined,
  totalAmount: number,
  cart: Cart
): MetaPixelPurchaseInput {
  return {
    orderId,
    orderNumber,
    totalAmount,
    items: (cart.cartItems ?? []).map((item) => ({
      productId: item.productId,
      merchantId: resolveMerchantId(item.product ?? { id: item.productId }),
      name: item.product.name,
      quantity: item.quantity,
      unitPrice: item.unitPrice,
    })),
  };
}

export function buildPurchaseInputFromSummary(summary: {
  orderNumber: string;
  totalAmount: number;
  items: Array<{ name: string; quantity: number; totalPrice: number }>;
}, orderId?: number): MetaPixelPurchaseInput {
  return {
    orderId,
    orderNumber: summary.orderNumber,
    totalAmount: summary.totalAmount,
    items: summary.items.map((item, index) => ({
      productId: index + 1,
      name: item.name,
      quantity: item.quantity,
      unitPrice: item.quantity > 0 ? item.totalPrice / item.quantity : item.totalPrice,
    })),
  };
}
